/* i18n-disable-file: 路由 meta.title 直接使用中文 key，消费方需在设置 document.title 时调 i18n.t(meta.title) 进行翻译 */
export default [
  {
    path: '/ac/findPwd',
    name: 'findPwd',
    component: () => import('@/pages/multi/findPsw/App.vue'),
    meta: {
      title: '找回密码',
    },
  },
];
